import React, {Component} from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Translation from "../../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { ORFButton } from "../../../../../common/forms/order-request-form.component";
import { Col, Form, Row } from "react-bootstrap";
import { wirelessChangeVendorActions } from "../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-vendor.reducer";
import { createRequestActions } from "../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "../../../../../../store/external/request-reducer/request-log.reducer";
import { SUBMIT_REQUEST, SUBMIT_REQUEST_TITLE } from "../../../../../../constants/external-constants";
import {
    OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
} from '../../../../../common/forms/order-request-form.component';
import { NotificationModal } from "../../../../../common/modal/notification-modal.component";
import { withRouter } from 'react-router-dom';
import { ConfirmationNotificationModal } from "../../../../../common/modal/confirmation-modal.component";
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import store from '../../../../../../store';
import { actions } from 'react-redux-form';
class ChangeVendorBusinessFormA extends Component {

    constructor(props) {
        super(props);
        this.state={
            show:false,
            message:"",
            isSaving:false, 
            showConModal:false,
            title: "",
          
        }
    }

    componentDidMount() {
        const { isUpdateRequest } = this.props.createRequest;
        const { requestDetail, wirelessChangeVendorFormA } = this.props;     
        const { businessCaseOptions } = this.props.wirelessChangeVendorRequest;
        if (isUpdateRequest && parseInt(requestDetail.requestData.BusinessJustification.BusJustiCodeDetailId) !== 0 && 
            businessCaseOptions.findIndex(r => parseInt(r.Key) === parseInt(requestDetail.requestData.BusinessJustification.BusJustiCodeDetailId) && 
            r.Value.toLowerCase() === 'other') > -1) {
            this.setState({ disableBusinessJustification: false })
        }      
        if (parseInt(wirelessChangeVendorFormA.busJustiCodeDetailId) === 0 || 
            businessCaseOptions.findIndex(r => parseInt(r.Key) === parseInt(wirelessChangeVendorFormA.busJustiCodeDetailId) && 
            r.Value.toLowerCase() !== 'other') > -1) {
            this.setState({ disableBusinessJustification: true })
        }            
  }  
    submitRequest = (event) => {
        event.preventDefault();
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
      
        if (buttonType === CONFIRMATION_VALUE.Ok) {
              const { submitRequest, fetchRequestLogItems } = this.props;
              this.setState( prev => ({
                isSaving:true,
             }))
                var success = await submitRequest();
                if (success.Success) {
                    fetchRequestLogItems(0);
                    this.setState({
                        title:"Success"
                    })
                    this.props.hideRequestModal(); 
                }else {
                    this.setState({
                        title:"Error"
                    })
                }
                this.setState( prev => ({
                    showConModal: !prev.showConModal,
                    show:true, 
                    isSaving:true,
                    message:success.Message
                }));                
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });   
        if(this.state.title!=="Error")
        {           
            this.props.history.goBack();
        } 
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    onChangeBusinessCase(model, value) {
        const { businessCaseOptions } = this.props.wirelessChangeVendorRequest;

        var disableBusinessJustification = businessCaseOptions.findIndex(r => parseInt(r.Key) === parseInt(value) && r.Value.toLowerCase() !== 'other') > -1;
        var businessCaseSelected = businessCaseOptions.find(r => parseInt(r.Key) === parseInt(value));
        var businessJustificationValue = disableBusinessJustification === true ? businessCaseSelected?.Value : "";

        store.dispatch(actions.change(model, value));
        store.dispatch(actions.change("wirelessChangeVendorFormA.businessJustification", businessJustificationValue));
        this.setState({
            disableBusinessJustification: disableBusinessJustification
        });
    }

    render(){

        const {
            //form
            wirelessChangeVendorFormA
            //reducer action
            , onPurposeOfUseSelect            
        } = this.props;
        const {
            requestData
        } = this.props.requestDetail;
        const { isUpdateRequest } = this.props.createRequest;
        const { 
              businessCaseOptions
            , purposeOfUseOptions           
            , formSubmitted
            } = this.props.wirelessChangeVendorRequest;

        const initialRequired = parseInt(wirelessChangeVendorFormA.circuitId) === 0
            || parseInt(wirelessChangeVendorFormA.newVendorId) === 0
            || parseInt(wirelessChangeVendorFormA.equipmentCatalogId) === 0            
            || parseInt(wirelessChangeVendorFormA.newPlanId) === 0           
            || wirelessChangeVendorFormA.businessJustification === ''
            || wirelessChangeVendorFormA.countryCode === ''
            || parseInt(wirelessChangeVendorFormA.locationId) === 0
            || parseInt(wirelessChangeVendorFormA.busJustiCodeDetailId) === 0
            || wirelessChangeVendorFormA.businessJustification === ''
            || parseInt(wirelessChangeVendorFormA.purposeOfUseDetailId) === 0
            || formSubmitted;

        const updateRequired = !((requestData.OtherLocationName !== '' ? requestData.OtherLocationName !== wirelessChangeVendorFormA.otherDeliveryAddress : wirelessChangeVendorFormA.otherDeliveryAddress != null)
            || parseInt(requestData.BillingAddress.LocationId) !== parseInt(wirelessChangeVendorFormA.locationId)
            || requestData.BillingAddress.CountryCode !== wirelessChangeVendorFormA.countryCode
            || parseInt(requestData.NewRequest.PlanDetails.PlanId) !== parseInt(wirelessChangeVendorFormA.newPlanId)
            || requestData.Subscription.PhoneCaseAccessory !== wirelessChangeVendorFormA.isPhoneAccessory
            || parseInt(requestData.Subscription.EquipmentInventoryId) !== parseInt(wirelessChangeVendorFormA.equipmentCatalogId)
            || parseInt(requestData.NewRequest.CircuitTypeId) !== parseInt(wirelessChangeVendorFormA.circuitTypeId)
            || parseInt(requestData.NewRequest.Vendor.VendorDetailId) !== parseInt(wirelessChangeVendorFormA.newVendorId)
            || parseInt(requestData.BusinessJustification.PurposeOfUseId) !==  parseInt(wirelessChangeVendorFormA.purposeOfUseDetailId)
            || parseInt(requestData.BusinessJustification.BusJustiCodeDetailId) !== parseInt(wirelessChangeVendorFormA.busJustiCodeDetailId)
            || requestData.BusinessJustification.BusinessJustification !== wirelessChangeVendorFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation !== wirelessChangeVendorFormA.additionalInformation);
       
        return(
            <div>

                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? SUBMIT_REQUEST.updateRequest : SUBMIT_REQUEST.submitRequest}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest :SUBMIT_REQUEST_TITLE.submitRequest}
                    disabled={this.state.isSaving}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <Form 
                    role="form"
                    model="wirelessChangeVendorFormA"
                    onSubmit={this.submitRequest}
                >            
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={<Translation translationKey="purpose_of_use" />}
                                options={purposeOfUseOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='wirelessChangeVendorFormA.purposeOfUseDetailId'
                                value={wirelessChangeVendorFormA.purposeOfUseDetailId}
                                onChangeAction={onPurposeOfUseSelect}
                                disabled={parseInt(wirelessChangeVendorFormA.circuitId) === 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={<Translation translationKey="business_case" />}
                                options={businessCaseOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='wirelessChangeVendorFormA.busJustiCodeDetailId'
                                value={wirelessChangeVendorFormA.busJustiCodeDetailId}
                                onChangeAction={(model, value) => this.onChangeBusinessCase(model, value)}                          
                            />
                        </Col>
                    </Row>
                    <Row>   
                        <Col xs={12} md={12} lg={12} className='required'>
                            <TextArea
                                label={<Translation translationKey="business_justification" />}
                                fieldProp='wirelessChangeVendorFormA.businessJustification'
                                value={wirelessChangeVendorFormA.businessJustification}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                disabled={this.state.disableBusinessJustification}
                                maxLength={MAX_LENGTH.limit_500}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={<Translation translationKey="additional_information" />}
                                fieldProp='wirelessChangeVendorFormA.additionalInformation'
                                value={wirelessChangeVendorFormA.additionalInformation}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                disabled={parseInt(wirelessChangeVendorFormA.circuitId) === 0}
                                maxLength={MAX_LENGTH.limit_1000}
                            />
                        </Col>
                    </Row>

                    <div className="request-button-continer">
                            <div className="bottom-left">
                                <ORFButton
                                    label={<Translation translationKey="modal_close_cancel_button" />}
                                    variant={"light"}
                                    action={this.props.onClickCancel}
                                    type="button"
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <ORFButton
                                        label={<Translation translationKey="back" />}
                                        variant={"outline-secondary"}
                                        action={this.props.prevAction}
                                        type="button"
                                        className="btn-custom-violet-hover-outline"
                                    />
                                </div>
                                <div>
                                    <ORFButton
                                        label={<Translation translationKey="submit_request_button" />}
                                        variant={"primary"}
                                        type="submit"
                                    disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired }
                                    />
                                </div>
                            </div>
                    </div> 
                    
                </Form>            
               
            </div>
        );
    }
}

export default withRouter ( connect(
    state => {
        const { wirelessChangeVendorRequest, createRequest, requestDetail, translation } = state;
        const { wirelessChangeVendorFormA } = state.form;
        return {
            wirelessChangeVendorRequest
            , wirelessChangeVendorFormA
            , createRequest
            , requestDetail
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessChangeVendorActions, createRequestActions, requestLogActions),
            dispatch
        )
)(ChangeVendorBusinessFormA));